import clsx from 'clsx';
import { Disclosure } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/outline';

const faqs = [
  {
    question: 'Nie widzę potrzeby naklejania kodów na książki.',
    answer:
      'System biblioteczny pomaga w gromadzeniu, katalogowaniu oraz udostępnianiu swoich zbiorów. Jeśli masz kilka pozycji ale odkrywasz w sobie pasję bibliofila, to dobry moment aby mieć listę książek pod kontrolą. Jeśli w swoim zbiorze masz więcej niż kilkadziesiąt pozycji to może zainteresować Cię wpis na blogu o wartości, którą posiadasz.',
  },
  {
    question: 'Naklejenie kodu spowoduje obniżenie wartości mojej książki.',
    answer:
      'Jeśli kupowałeś kiedyś używane książki, to wiesz, że ich wartość jest opisywana wyłącznie poprzez negatywne cechy - poziom zniszczenia, zadarcia, zużycia, stempli. Dodając kod youtalky do książki, dodajesz do niej wartość, która płynie z obecności systemu katalogowania. Dodanie jej do własnego katalogu, informacje o właścicielu, możliwość dodania dźwięku do sejfu egzemplarza. Ponadto możesz wybrać rodzaj etykiety przed zakupem lub dodać własny ex libris. Nowa książka po zakupie - jeśli nie ma etykiety - od razu traci na wartości. Skataloguj ją, aby tego uniknąć.',
  },
];

export default function FAQ() {
  return (
    <div className="bg-gray-50">
      <div className="mx-auto max-w-7xl py-12 px-6 sm:py-16 lg:px-8">
        <div className="mx-auto max-w-3xl divide-y-2 divide-gray-200">
          <h2 className="text-center text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Często Pomyślane Wątpliwości
          </h2>
          <dl className="mt-6 space-y-6 divide-y divide-gray-200">
            {faqs.map((faq) => (
              <Disclosure as="div" key={faq.question} className="pt-6">
                {({ open }) => (
                  <>
                    <dt className="text-lg">
                      <Disclosure.Button className="flex w-full items-start justify-between text-left text-gray-400">
                        <span className="font-medium text-gray-900">{faq.question}</span>
                        <span className="ml-6 flex h-7 items-center">
                          <ChevronDownIcon
                            className={clsx(open ? '-rotate-180' : 'rotate-0', 'h-6 w-6 transform')}
                            aria-hidden="true"
                          />
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel as="dd" className="mt-2 pr-12">
                      <p className="text-base text-gray-500">{faq.answer}</p>
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}
